import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UxDesignComponent } from './ux-design.component';

const routes: Routes = [{
    path: '',
    component: UxDesignComponent
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UxDesignRoutingModule { }
